export default "__VITE_ASSET__CKY4T9sp__"